module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image09-d4c9acc40b60697200e7a2a2ee8db96e.png";